import Jed         from 'jed';
import { sprintf } from 'sprintf-js';

if (!String.prototype.format) {
	String.prototype.format = function(...args) {
		return sprintf(this, ...args);
	};
}

// Returned strings can also be formatted.
// e.g.
// * `tc("%s is your uncle").format("Bob")` = `Bob is your uncle`
// * `tc("%s is your uncle") = `%s is your uncle`
export class Translator {
	constructor( jedOptions ) {
		this.configureJed(jedOptions);
	}
	
	configureJed(jedOptions) {
		jedOptions            = jedOptions || {};
		jedOptions[ 'debug' ] = false;
		this.jed              = new Jed( jedOptions );
	}
	
	// Translates a key within a context
	tc( context, key ) {
		if ( !context ) {
			return this.t( key );
		}
		return this.jed.pgettext( context, key );
	}
	
	// Translates a key without context
	t( key ) {
		return this.jed.gettext( key );
	}
	
	static _loaderForLanguage( lang ) {
		lang = lang.split( '-' )[ 0 ];
		// These imports must be predefined - hence the switch
		switch ( lang ) {
			case 'da':
				return import('./messages.da.po');
			case 'en':
				return import('./messages.en.po');
			case 'fi':
				return import('./messages.fi.po');
			case 'fr':
				return import('./messages.fr.po');
			case 'nb':
				return import('./messages.nb.po');
			case 'sv':
				return import('./messages.sv.po');
			default:
				return Promise.reject( new Error( `unknown language: ${lang}` ) );
		}
	}
	
	get dayNames() {
		return [
			this.tc( 'DateTime', 'Sun' ),
			this.tc( 'DateTime', 'Mon' ),
			this.tc( 'DateTime', 'Tue' ),
			this.tc( 'DateTime', 'Wed' ),
			this.tc( 'DateTime', 'Thu' ),
			this.tc( 'DateTime', 'Fri' ),
			this.tc( 'DateTime', 'Sat' ),
			this.tc( 'DateTime', 'Sunday' ),
			this.tc( 'DateTime', 'Monday' ),
			this.tc( 'DateTime', 'Tuesday' ),
			this.tc( 'DateTime', 'Wednesday' ),
			this.tc( 'DateTime', 'Thursday' ),
			this.tc( 'DateTime', 'Friday' ),
			this.tc( 'DateTime', 'Saturday' )
		];
	}
	
	/* 1 = Mon, 0 and 7 = Sun */
	shortDayName(index) {
		return this.dayNames[index % 7];
	}
	
	/* 1 = Monday, 0 and 7 = Sunday */
	longDayName(index) {
		return this.dayNames[index % 7 + 7]
	}
	
	get monthNames() {
		return [
			this.tc( 'DateTime', 'Jan' ),
			this.tc( 'DateTime', 'Feb' ),
			this.tc( 'DateTime', 'Mar' ),
			this.tc( 'DateTime', 'Apr' ),
			this.tc( 'DateTime', 'May' ),
			this.tc( 'DateTime', 'Jun' ),
			this.tc( 'DateTime', 'Jul' ),
			this.tc( 'DateTime', 'Aug' ),
			this.tc( 'DateTime', 'Sep' ),
			this.tc( 'DateTime', 'Oct' ),
			this.tc( 'DateTime', 'Nov' ),
			this.tc( 'DateTime', 'Dec' ),
			this.tc( 'DateTime', 'January' ),
			this.tc( 'DateTime', 'February' ),
			this.tc( 'DateTime', 'March' ),
			this.tc( 'DateTime', 'April' ),
			this.tc( 'DateTime', 'May' ),
			this.tc( 'DateTime', 'June' ),
			this.tc( 'DateTime', 'July' ),
			this.tc( 'DateTime', 'August' ),
			this.tc( 'DateTime', 'September' ),
			this.tc( 'DateTime', 'October' ),
			this.tc( 'DateTime', 'November' ),
			this.tc( 'DateTime', 'December' )
		];
	}
	
	get dateFormatLong() {
		return this.tc( 'DateTime', 'ddd, mmm dd. yyyy - HH:MM' );
	}
	
	get dateFormatShort() {
		return this.tc( 'DateTime', 'dd/mm/yyyy' );
	}
	
	async setLanguage(lang) {
		let conf = await(Translator._loaderForLanguage(lang));
		this.configureJed(conf);
	}
	
	
	// Translates HTML-i18n in the active page.
	// * Translates text of elements with attribute `i18n`.
	// * Translates `aria-label` where attribute `i18n-aria-label` is set.
	// Attribute `i18n-context` optionally specifies context.
	translateHtml() {
		const self = this;
		$( '[i18n]' ).each( function () {
			let item = this;
			let ctx  = item.getAttribute( 'i18n-context' );
			let key  = item.getAttribute( 'i18n-key' );
			if ( !key ) {
				key = item.textContent;
				item.setAttribute( 'i18n-key', key );
			}
			item.textContent = self.tc( ctx, key );
		} );
		
		$( '[i18n-aria-label]' ).each( function () {
			let item = this;
			let ctx  = item.getAttribute( 'i18n-context' );
			let key  = item.getAttribute( 'i18n-aria-label-key' );
			if ( !key ) {
				key = item.getAttribute( 'aria-label' );
				item.setAttribute( 'i18n-aria-label-key', key );
			}
			item.setAttribute( 'aria-label', self.tc( ctx, key ) );
		} );
	}
}